import { DialogInputType, LtnDialogService } from '../../../../ltn-dialog/ltn-dialog-service.js';
import { PUBLIC_REASON_MAX } from './trust-score-review-logic.js';

/**
 * The support cards' Suppress question: suppressing shows everyone 0 and stops the company's re-checks, so the card asks first,
 * and for the public reason shown beside the 0. Resolves to the reason as typed, or null when cancelled.
 */
export async function confirmSuppress(dialog: LtnDialogService | undefined): Promise<string | null> {
  const title = "Suppress this company's trust score?";
  const description =
    "Every company will see this company's trust score as 0 with the public reason below, and its scores stop being re-checked until it is published again.";
  if (!dialog) {
    return window.prompt(`${title}\n\n${description}\n\nPublic reason (everyone sees this)`) ?? null;
  }
  try {
    const answer = await dialog.open(
      { title, description, actionLabel: 'Suppress' },
      {
        sections: [
          {
            key: 'suppress',
            title: '',
            inputs: [
              {
                type: DialogInputType.TEXT,
                label: 'Public reason (everyone sees this)',
                name: 'publicReason',
                value: '',
                classes: {},
                maxlength: PUBLIC_REASON_MAX,
                hint: `Shown to every company beside the score of 0, at most ${PUBLIC_REASON_MAX} characters. The notes stay internal.`,
              },
            ],
          },
        ],
      },
    );
    return answer.values?.suppress?.publicReason ?? '';
  } catch {
    return null;
  }
}
